import { createAction, props } from '@ngrx/store';

export const initAuthorizeWithPopUp = createAction('[Common Auth] Init authorize with pop-up');
export const completeAuthorizeWithPopUp = createAction('[Common Auth] Complete authorize with pop-up');
export const failedAuthorizeWithPopUp = createAction(
  '[Common Auth] Failed authorize with pop-up',
  props<{ error: unknown }>()
);
